export default {
  "overviewTitle": "Membership overview",
  "core": "Key metrics",
  "change": "vs. last month",
  "noPrevious": "No data for last month",
  "trendTitle": "Membership revenue over the last 6 months",
  "topTitle": "Top 10 subscribing companies",
  "rank": "Rank",
  "company": "Company / organization",
  "plan": "Membership plan",
  "amount": "Activation amount",
  "emptyOrders": "No activation records yet",
  "planDistribution": "Membership plan distribution",
  "planCenter": "Plan\nshare",
  "sourceDistribution": "Membership source distribution",
  "sourceCenter": "Activation\nsource",
  "statusDistribution": "Membership status distribution",
  "statusCenter": "Member\nstatus",
  "newMembers": "New members this month",
  "monthRevenue": "Membership revenue this month",
  "activatedCompanies": "Companies activated this month",
  "totalRevenue": "Total membership revenue",
  "premium": "Premium members",
  "customMembers": "Custom members",
  "soon": "Expiring within 30 days",
  "average": "Average plan value",
  "defaultPlan": "Default plan",
  "custom": "Custom",
  "defaultDescription": "Suitable for event organizers of different sizes.",
  "free": "Free",
  "permanentValid": "Never expires",
  "quotas": "Resource quotas",
  "activities": "Events",
  "albums": "Photo Live",
  "forms": "Forms",
  "donations": "Donations",
  "nameCards": "Name cards",
  "storage": "Cloud storage",
  "sms": "SMS",
  "logo": "Footer logo",
  "customLogo": "Custom",
  "defaultLogo": "Platform default",
  "features": "Included features",
  "emptyFeatures": "No additional features",
  "editPlan": "Edit plan",
  "subscribers": "View subscribers",
  "delete": "Delete",
  "emptyPlans": "No plans yet",
  "category": "Plan category",
  "platformCategory": "Platform plan (public sales to companies and liaisons)",
  "customCategory": "Custom plan (invitation only)",
  "basic": "Basic information",
  "permanent": "Permanent",
  "limited": "Fixed term",
  "daysPlaceholder": "Days",
  "days": "days",
  "zeroUnlimited": "0 means unlimited",
  "onePerLine": "One item per line",
  "remark": "Plan notes",
  "remarkPlaceholder": "Additional notes shown at the bottom of the plan card",
  "cancel": "Cancel",
  "memberNo": "Member ID",
  "companyName": "Company / organization",
  "contact": "Contact",
  "phone": "Phone",
  "expires": "Expires at",
  "eventsCreated": "Events created",
  "status": "Status",
  "expired": "Expired",
  "active": "Active",
  "actions": "Actions",
  "details": "Details",
  "close": "Close",
  "unlimited": "Unlimited",
  "saved": "Plan saved",
  "saveFailed": "Could not save the plan. Please try again.",
  "deleteTitle": "Delete plan",
  "deleted": "Plan deleted",
  "verification": "Verification type",
  "enterprise": "Organization verification",
  "personal": "Personal verification",
  "buyout": "(Lifetime purchase)",
  "guide": "Platform plans are sold publicly on the website to companies and event liaisons. Custom plans support the specific needs of medium and large companies: configure dedicated resource quotas, then generate an activation link and invite the company. Changes take effect immediately; review them carefully.",
  "trendNote": "Currency: CNY · Peak {amount}",
  "companyCount": "{n} companies",
  "validDays": "Valid for {n} days",
  "subscriberTitle": "Subscribers · {name}",
  "subscriberCount": "{n} subscribing companies",
  "deleteConfirm": "Delete plan “{name}”?",
  "sourceSelf": "Website self-service",
  "sourceProxy": "Liaison invitation",
  "sourceEnterprise": "Company referral",
  "normalMembers": "Standard members",
  "customMemberLabel": "Custom members",
  "nameRequired": "Enter a plan name"
}
